export const CategoryLists = {
  QLED: {
  	title: 'QLED / UHD TVs',
  	list: {
  		QLED8k: {
  			title: 'QLED8K',
  			url: 'qled8k',
  			nav: 'QLED',
  		},
      OLED: {
  			title: 'OLED',
  			url: 'OLED',
  			nav: 'OLED',
  		},
  		UHD: {
  			title: 'UHD',
  			url: 'uhd',
  			nav: 'UHD',
  		},
      FHD: {
  			title: 'FHD',
  			url: 'FHD',
  			nav: 'FHD',
  		},
      HD: {
  			title: 'HD',
  			url: 'HD',//image title
  			nav: 'HD',
  		},
      
  	},
  },
  Lifestyle: {
    title: 'Lifestyle TVs',
    list: {
      Serif: {
        title: 'theSerif',
        url: 'serif',
        nav: 'The Serif',
      },
      Sero: {
        title: 'theSero',
        url: 'sero',
        nav: 'The Sero',
      },
      Frame: {
        title: 'theFrame',
        url: 'frame',
        nav: 'The Frame',
      },
      Terrace: {
        title: 'theTerrace',
        url: 'terrace',
        nav: 'The Terrace',
      },
      Premiere: {
      	title: 'thePremiere',
      	url: 'premiere',
      	nav: 'The Premiere',
      },
      TheFreeStyle: {
      	title: 'TheFreeStyle',
      	url: 'TheFreestyle',
      	nav: 'The Freestyle',
      },
    },
  },
  Monitors: {
    title: 'Monitors',
    list: {
      GamingMonitor: {
        title: 'Monitors',
        url: 'Monitors',
        nav: 'Monitors',
      },
      OdysseyArk: {
        title: 'OdysseyArk',
        url: 'OdysseyArk',
        nav: 'Odyssey Ark',
      },
    },
  },

  HomeAudio: {
  	title: 'Home Audios',
  	list: {
      SoundbarSetOne: {
  			title: 'SoundbarSet01',
  			url: 'Soundbar set01',
  			nav: 'Soundbar Set1',
  		},
      SoundbarSetTwo: {
  			title: 'SoundbarSet02',
  			url: 'Soundbar set02',
  			nav: 'Soundbar Set2',
  		},
  		Soundbar: {
  			title: 'Soundbar',
  			url: 'Soundbar',
  			nav: 'Soundbar',
  		},
      TheTerraceSoundBar: {
  			title: 'TheTerraceSoundbar',
  			url: 'TheTerraceSoundBar',
  			nav: 'The Terrace Soundbar',
  		},
      SoundTower:{
        title:'Soundtower',
        url:'Soundtower',
        nav:'Sound Tower'
      }
  	},
  },
  Vacuum:{
    title:'Vacuums',
    list:{
      BespokeJet:{
        title:'BespokeJet',
        url:'BespokeJet',
        nav:'BESPOKE Jet',
      },
      BespokeJetStation:{
        title:'BespokeJetStation',
        url:'BespokeJetStation',
        nav:'BESPOKE Jet(Clean Station™)'
      },
      BespokeJetNCleanStation:{
        title:'BespokeJetNCleanStation',
        url:'BespokeJetNCleanStation',
        nav:'BESPOKE Jet&Clean Station™'
      },
      BespokeSlim:{
        title:'BespokeSlim',
        url:'Bespoke_slim',
        nav:'BESPOKE Slim'
      },
      BespokeSlimCleanStation:{
        title:'BespokeSlimCleanStation',
        url:'BespokeSlimCleanStation',
        nav:'BESPOKE Slim&Jet(Clean Station™)'
      },
      JetCleanStation:{
        title:'JetCleanStation',
        url:'JetCleanStation',
        nav:'Jet&Clean Station™'
      },
      BespokeJetbot:{
        title:'BespokeJetbot',
        url:'BespokeJetbot',
        nav:'BESPOKE Jet Bot'
      },
      BespokeJetbotPlus:{
        title:'BespokeJetbotPlus',
        url:'BespokeJetbotPlus',
        nav:'BESPOKE Jet Bot+'
      },
      BespokeJetbotAI:{
        title:'BespokeJetbotAI',
        url:'BespokeJetbotAI',
        nav:'BESPOKE Jet Bot AI'
      },
      Canister01:{
        title:'Canister01',
        url:'Canister01',
        nav:'Canister01'
      },
      Canister02:{
        title:'Canister02',
        url:'Canister02',
        nav:'Canister02'
      },
      Jupiter:{
        title:'Jupiter',
        url:'Jupiter',
        nav:'Samsung Vacuum Cleaner'
      },
    },
  },
  Airpurifier:{
    title:'Air Solutions',
    list:{
      BespokeCube53:{
        title:'BespokeCube53',
        url:'bespoke_cubeAir53',
        nav:'BESPOKE Cube™ AIR(53㎡)',
      },
      BespokeCube70:{
        title:'BespokeCube70',
        url:'bespoke_cubeAir70',
        nav:'BESPOKE Cube™ AIR(70㎡)'
      },
      BespokeCube106:{
        title:'BespokeCube106',
        url:'bespoke_cubeAir106',
        nav:'BESPOKE Cube™ AIR(106㎡)'
      },
      BespokeCube123:{
        title:'BespokeCube123',
        url:'bespoke_cubeAir123',
        nav:'BESPOKE Cube™ AIR(123㎡)'
      },
      BlueSky:{
        title:'BlueSky',
        url:'BlueSky',
        nav:'BlueSky 5500'
      },
      BlueSky5000:{
        title:'BlueSky5000',
        url:'BlueSky5000',
        nav:'BlueSky 5000'
      },
      BlueSky3100:{
        title:'BlueSky3100',
        url:'BlueSky3100',
        nav:'BlueSky 3100'
      },
      BlueSky3000:{
        title:'BlueSky3000',
        url:'BlueSky3000',
        nav:'BlueSky 3000'
      }
    },
  },

  Microwaves:{
    title:"Kitchen",
    list:{
      WaterPurifier:{
        title:'WaterPurifier',
        url:'WaterPurifier',
        nav:'WaterPurifier',
      },
      Qooker:{
        title:'Qooker',
        url:'Qooker',
        nav:'Qooker',
      },
      LATIN:{
        title:'LATIN',
        url:'LATIN',
        nav:'LATIN',
      },
      LATIN10:{
        title:'LATIN10',
        url:'LATIN10',
        nav:'LATIN10',
      },
      MIRROR:{
        title:'MIRROR',
        url:'MIRROR',
        nav:'MIRROR',
      },
      MW5100J:{
        title:'MW5100J',
        url:'MW5100J',
        nav:'MW5100J',
      },
      STENA:{
        title:'STENA',
        url:'STENA',
        nav:'STENA',
      }
    }
  },
  Refrigerator:{
    title:"Refrigerator",
    list:{
      ref_cube:{
        title:'ref_cube',
        url:'ref_cube',
        nav:'BESPOKE Cube',
      }
    }
  },
};
